module.exports = __webpack_public_path__ + "static/236229175-c5078c1f7c7acefd3c05a8fda06b5d92.jpg";